// 企業通用版
export const E_GENERIC = 'generic'
